<template>
  <Loading v-if="isLoading" />
  <div class="content-wrap am-page-wrap" :class="amPage">
    <div class="navi-area">
      <div class="m-navi-top">
        <c-btn01 :btnText="t('message.goToHome')" @click="utils.movePage('/actionManagement')"/>
      </div>
      <NaviBox @closeMobileMenu="amListOpen"/>
    </div>
    <div class="page1">
      <div class="page1-inner1">
        <div class="tit-group02">
          <div class="tit-group02-wrap">
            <h2 class="tit">{{t('message.currentMonth')+' '+t('message.quickKPI')}}</h2>
            <p class="txt">{{thisMonth}}</p>
            <c-tooltip :TooltipText="t('message.monthlyMonitoringSummary')"/>
            <div class="area-r">
              <c-InputDate v-model="monthDate" :enableTimePicker="false" readonly="" name="monthDate" :isMonth="true" :formatType="'yyyy-MM'" />
            </div>
          </div>
          <div class="navi-btn">
            <v-btn @click="amListOpen"/>
          </div>
        </div>
        <div class="card-group02">
        <div class="card-col ty01">
          <div class="icon ico1" aria-hidden="true"></div>
          <div class="txt-group">
            <div class="txt1">{{ allAnswerCnt }}</div>
            <div class="txt2">{{t('message.participationFrequency')}}
              <c-tooltip :TooltipText="t('message.actualMonitoringCount')"/>
            </div>
          </div>
          <div class="line"></div>
          <div class="txt-group">
            <div class="txt1">{{ periodAnswerCnt }}</div>
            <div class="txt2">{{t('message.goalAchievement')}}
              <c-tooltip :TooltipText="t('message.achievementStatusBasedOnTarget')"/>
            </div>
          </div>
        </div>
        <div class="card-col ty01">
          <div class="icon ico1" aria-hidden="true"></div>
          <div class="txt-group">
            <div class="txt1">{{ allAnswerPercent }}<span>%</span></div>
            <div class="txt2">{{t('message.participationRate')}}<span class="sub-txt">{{`(${allAnswerCnt}/${allPeriodCnt})`}}</span></div>
          </div>
          <div class="line"></div>
          <div class="txt-group">
            <div class="txt1">{{ periodAnswerPercent }}<span>%</span></div>
            <div class="txt2">{{t('message.goalAchievementRate')}}<span class="sub-txt">{{`(${periodAnswerCnt}/${allPeriodCnt})`}}</span></div>
          </div>
        </div>
        <div class="card-col ty02">
          <div class="icon ico2" aria-hidden="true"></div>
          <div class="txt-group">
            <div class="txt1">{{ timelineTy1CompleteCnt }}</div>
            <div class="txt2">{{t('message.correctiveActionCount')}}</div>
          </div>
        </div>
        <div class="card-col ty02">
          <div class="icon ico2" aria-hidden="true"></div>
          <div class="txt-group">
            <div class="txt1">{{ timelineTy1Percent }}<span>%</span></div>
            <div class="txt2">{{t('message.correctiveActionRate')}}<span class="sub-txt">{{`(${timelineTy1CompleteCnt}/${timelineTy1Cnt})`}}</span></div>
          </div>
        </div>
      </div>
      </div>
      <div class="page1-inner2">
        <div class="tit-group02">
          <h2 class="tit">{{t('message.timeline')}}</h2>
          <div class="srch-txt">
            <div class="txt01">{{ t('message.searchResult')?t('message.searchResult'):'검색결과' }}</div>
            <div class="txt02">{{ items.length }}{{t('message.count')}}</div>
          </div>
        </div>
        <div class="content-box">
          <div class="sort-group">
            <div class="sort-row ty01">
              <div class="wl">
                <div class="txt01">{{t('message.period')}}</div>
                <div class="date-sort">
                  <c-InputDate v-model="startDate" :enableTimePicker="false" readonly="" name="startDate" />
                  <div class="txt02">~</div>
                  <c-InputDate v-model="endDate" :enableTimePicker="false" readonly="" name="endDate"/>
                </div>
                <div class="date-sort">
                  <c-btn02 :btnText="t('message.week')" class="ty01" @click="onClickDate('week')"/>
                  <c-btn02 :btnText="t('message.quarter')" class="ty01" @click="onClickDate('quarter')"/>
                  <c-btn02 :btnText="t('message.year2')" class="ty01" @click="onClickDate('year')"/>
                </div>
                <Select v-bind="typeSelect" v-model="typeModel"/>
              </div>
              <div class="wr">
                <c-btnText01 :btnText="t('message.viewAll')" class="ty01" @click="onClickAll"/>
              </div>
            </div>
          </div>
          <div class="slider-group">
            <v-slide-group
              v-model="model"
              center-active
              show-arrows
              delimiters
            >
              <v-slide-group-item
                v-for="(item,i) in items"
                :key="i"
                v-slot="{ isSelected, toggle }"
              >
                <v-card
                  :class="item.type=='2'?'ty01':''"
                  @click="toggle"
                >
                  <div class="slider-item">
                    <div class="img-slider">
                      <v-carousel
                      >
                        <v-carousel-item
                          v-for="(item2,i2) in item.timelineImages"
                          :key="i2"
                          :src="utils.getBaseUrl('timeline', item2.filePath)"
                          cover
                          @click="onClickPreview(item2)"
                        ></v-carousel-item>
                      </v-carousel>
                    </div>
                    <div @click="onClickDetail(item)">
                      <div class="txt-group">
                        <div class="txt ell01">{{ item.memberName?item.memberName:t('message.noInfo') }} / {{ item.deptName?item.deptName:t('message.noInfo') }} / {{ item.posName?item.posName:t('message.noInfo') }}</div>
                        <div class="txt2">{{ item.regDateFormat }}</div>
                      </div>
                      <ul class="txt-group2">
                        <li v-if="item.type=='1'">
                          <div class="tit">{{t('message.monitoringBehavior')}}</div>
                          <div class="txt ell01">{{ item.behaviorTitle }}</div>
                        </li>
                        <li v-if="item.type=='1'">
                          <div class="tit">{{t('message.location')}}</div>
                          <div class="txt ell01">{{ item.placeName }}</div>
                        </li>
                        <li>
                          <div class="tit">{{item.type=='1'?t('message.specificSituation'):t('message.praiseReason')}}</div>
                          <div class="txt ell01">{{ item.situation }}</div>
                        </li>
                        <li v-if="item.type=='1'">
                          <div class="tit">{{t('message.cause')}}</div>
                          <div class="txt ell01">{{ item.cause }}</div>
                        </li>
                        <li v-if="item.type=='1'">
                          <div class="tit">{{t('message.correctiveActionDetails')}}</div>
                          <div class="txt ell01">{{ item.action }}</div>
                        </li>
                        <li>
                          <div class="tit">{{item.type=='1'?t('message.correctiveActionTarget'):t('message.praiseTarget')}}</div>
                          <div class="txt ell01">{{ item.targetText }}</div>
                        </li>
                        <li v-if="item.actionYn=='Y'">
                          <div class="tit">{{t('message.actionDeadline')}}</div>
                          <div class="txt ell01">{{ item.goalDate }}</div>
                        </li>
                        <li v-if="item.type=='1'">
                          <div class="tit">{{t('message.progressStatus')}}</div>
                          <div class="txt2 c01">{{ item.statusText }}</div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </v-card>
              </v-slide-group-item>
            </v-slide-group>
          </div>
        </div>
      </div>
      <div class="page1-inner3">
        <div class="tit-group02">
          <h2 class="tit">{{t('message.menu')}}</h2>
        </div>
        <div class="m-menu-list">
          <v-btn class="n1" @click="amListOpen">{{t('message.monitoring')}}</v-btn>
          <v-btn class="n2" @click="utils.movePage('/actionManagementAll')">{{t('message.timeline')}}</v-btn>
          <v-btn class="n3" @click="utils.movePage('/totalReport')">{{t('message.report')}}</v-btn>
          <v-btn class="n4" @click="utils.movePage('/myBoard')">{{t('message.correctiveAction')}}</v-btn>
        </div>
      </div>
    </div>
  </div>
  <AmDialog01 v-model="detailPopupModel" @close="detailPopupModel=false" @delete="deleteAmDialog"/>
  <DialogImgView v-model="previewDialog" @close="previewDialog=false" :src="previewSrc"/>
  <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import TimelineService from "@/services/timeline.service";
import BbsService from "@/services/bbs.service";
import utils from "@/common/Utils";
import {useCommonStore} from "@/store/common";
import {storeToRefs} from "pinia";
import _ from 'lodash';
import dayjs from "dayjs";
import { useI18n } from 'vue-i18n';
import quarterOfYear from "dayjs/plugin/quarterOfYear";
const { t } = useI18n();

//plugin
dayjs.extend(quarterOfYear)

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)

//bind
const isLoading = ref<boolean>(false)
const snackbar = ref(false)
const snackText = ref('')
const detailPopupModel = ref(false)
const previewDialog = ref(false)
const startDate = ref('')
const endDate = ref('')
const monthDate = ref(dayjs().format('YYYY-MM'))
const items = ref([])
const amPage = ref('naviOff')
const typeModel = ref('1')
const periodAnswerCnt = ref(0)
const allAnswerCnt = ref(0)
const allPeriodCnt = ref(0)
const periodAnswerPercent = ref(0)
const allAnswerPercent = ref(0)
const timelineTy1Cnt = ref(0)
const timelineTy1CompleteCnt = ref(0)
const timelineTy1Percent = ref(0)
const previewSrc = ref('')
const model = ref(0)
const thisMonth = ref('')

//ui
const typeSelect = computed(() => ( {items: [{name:t('message.individualViewUnit'), value:'1'},{name:t('message.departmentViewUnit'), value:'2'},{name:t('message.organizationViewUnit'), value:'3'}]} ))

//hook
onMounted(() => {
  onClickDate('week')
  onSearchKPI()
  typeModel.value = storeRef.timelineType.value?storeRef.timelineType.value:typeModel.value
  storeRef.timelineType.value = '1'
  onClickSearch()
})

//function
function amListOpen(){
  if(amPage.value == 'naviOff')
    amPage.value = 'naviOn'
  else
    amPage.value = 'naviOff'
}

function onClickPreview(item){
  previewSrc.value = utils.getBaseUrl('timeline', item.filePath)
  previewDialog.value = true
}

function onClickDetail(item){
  storeRef.popupIdx.value = item.idx
  detailPopupModel.value = true
}

function onClickDate(type){
  let end = dayjs().format('YYYY-MM-DD')
  let start = dayjs().format('YYYY-MM-DD')
  if(type == 'quarter') {
    end = dayjs().endOf('quarter').format('YYYY-MM-DD')
    start = dayjs().startOf('quarter').format('YYYY-MM-DD')
  }
  else if(type == 'year') {
    end = dayjs().endOf('year').format('YYYY-MM-DD')
    start = dayjs().startOf('year').format('YYYY-MM-DD')
  }
  else if(type == 'week') {
    end = dayjs().format('YYYY-MM-DD')
    start = dayjs().subtract(7, 'day').format('YYYY-MM-DD')
  }

  startDate.value = start.toString()
  endDate.value = end.toString()
}

const onSearchKPI=()=>{
  const params = {
    companyIdx : JSON.parse(localStorage.getItem('companyIdx')),
    startDate : dayjs(monthDate.value).startOf('month').format('YYYY-MM-DD'),
    endDate : dayjs(monthDate.value).endOf('month').format('YYYY-MM-DD'),
    isExclude: 'N'
  }

  BbsService.getBbsMonitoringSummary(params).then(
    (response) => {
      periodAnswerCnt.value = response.result.periodAnswerCnt // 기간별 제한 관찰 참여빈도
      allAnswerCnt.value = response.result.allAnswerCnt // 전체 관찰 참여빈도
      allPeriodCnt.value = response.result.allPeriodCnt // 전체 관찰 참여빈도
      periodAnswerPercent.value = response.result.periodAnswerPercent     // 기간별 제한 관찰 참여빈도 달성율
      allAnswerPercent.value = response.result.allAnswerPercent // 전체 관찰 참여빈도 달성율
      timelineTy1Cnt.value = response.result.timelineTy1Cnt //시정조치 횟수
      timelineTy1CompleteCnt.value = response.result.timelineTy1CompleteCnt //시정조치 완료 횟수
      timelineTy1Percent.value = response.result.timelineTy1Percent //시정조치 완료율

      thisMonth.value = `(${t('message.totalRequiredCount')} : ${response.result.allPeriodCnt}${t('message.countUnit')})`
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const onClickSearch=()=>{
  isLoading.value = true
  const companyIdx = JSON.parse(localStorage.getItem('companyIdx'))
  let params = {
    startDate:startDate.value,
    endDate:endDate.value,
    filterType:typeModel.value,
    companyIdx:companyIdx,
    isTemp:'N'
  }

  TimelineService.getTimelineList(params).then(
    (response) => {
      isLoading.value = false
      //타임라인
      items.value = response.result
      _.forEach(items.value, function(val, key) {
        val.typeText = val.type=='1'?t('message.correctiveSafetyTalk'):t('message.supportiveSafetyTalk')
        val.actionYnText = val.actionYn=='Y'?t('message.necessary'):t('message.notNecessary')
        val.targetText = t('message.none')
        if(val.targetType == '2') val.targetText = val.targetDeptName
        else if(val.targetType == '3') val.targetText = val.targetMemberName
        val.goalDate = dayjs(val.goalDate).format('YYYY-MM-DD') == 'Invalid Date' ? '':dayjs(val.goalDate).format('YYYY-MM-DD')
        val.statusText = t('message.ready')
        if(val.status == '2')
          val.statusText = t('message.inProgress')
        else if(val.status == '3')
          val.statusText = t('message.onHold')
        else if(val.status == '4')
          val.statusText = t('message.complete')
      })
      model.value = 0
    },
    (error) => {
      isLoading.value = false
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const onClickAll = ()=>{
  storeRef.timelineType.value = typeModel.value
  utils.movePage('/actionManagementAll')
}

const deleteAmDialog=(idx)=>{
  _.remove(items.value, item =>item.idx == idx)
}

//watch
watch(startDate, (newObj) => {
  onClickSearch()
})

watch(endDate, (newObj) => {
  onClickSearch()
})

watch(typeModel, (newObj) => {
  onClickSearch()
})
watch(monthDate, (newObj) => {
  onSearchKPI()
})
</script>
<style lang="scss">
</style>
